import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, InputComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { TFAService } from 'mbs-ui-shared@services/tfa.service';
import { catchError, of, take } from 'rxjs';

@Component({
  selector: 'mbs-change-email-modal',
  templateUrl: './change-email-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    InputComponent,
    ModalFooterDirective
  ]
})
export class ChangeEmailModalComponent {
  auth = inject(AuthFacade);
  private cdr = inject(ChangeDetectorRef);
  private TFAService = inject(TFAService);

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public loading = false;

  public form: UntypedFormGroup = new UntypedFormGroup({
    email: new FormControl(null, [Validators.required]),
    password: new FormControl(null, [Validators.required])
  });

  public passwordType: 'text' | 'password' = 'password';
  public MbsPopupType = MbsPopupType;

  public isEmailChanged = false;
  public newEmail = null;
  public oldEmail = null;

  changePasswordType(): void {
    this.passwordType = this.passwordType == 'password' ? 'text' : 'password';
  }

  show2FAConfirm(data): Promise<unknown> {
    return this.TFAService.openApproveModal(data);
  }

  changeEmail(): void {
    this.loading = true;

    this.auth
      .changeEmail(this.form.value)
      .pipe(
        take(1),
        catchError((error) => of(error))
      )
      .subscribe((result) => {
        this.loading = false;
        if (result?.error?.authId) {
          this.show2FAConfirm(result.error)
            .then(() => this.changeEmail())
            .catch(() => this.baseModal.close());
        } else if (result.currentEmail === result.newEmail) {
          this.baseModal.save();
        } else {
          this.isEmailChanged = true;
          this.newEmail = result.newEmail;
          this.oldEmail = result.currentEmail;
          this.cdr.detectChanges();
        }
      });
  }
}
